import { useMutation } from '@tanstack/react-query';
import { useGroupApi } from 'services';

export const useDenyInvitation = () => {
  const { denyPendingGroupJoinRequest } = useGroupApi();

  return useMutation({ mutationFn: denyPendingGroupJoinRequest });
};
